<template>
  <span class="badge badge-primary">New in 1.5</span>
</template>

<script>
export default {
  name: "NewBadge"
}
</script>

<style scoped>

</style>